// Blogger.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Blogger.css';

const Blogger = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch('https://api.dikshasea.in/api/posts/published');
        if (!res.ok) throw new Error('Fetch failed');
        const data = await res.json();
        setPosts(data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const formatDate = (d) => new Date(d).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
    // hour: '2-digit', minute: '2-digit',
  });

  const filtered = posts.filter(p =>
    p.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.content.toLowerCase().includes(searchTerm.toLowerCase())
  );
    const cleanContent = (html, maxLength = 100) => {
    if (!html) return '';
    const stripped = html.replace(/<[^>]+>/g, '');
    return stripped.length > maxLength
      ? stripped.substring(0, maxLength) + '...'
      : stripped;
  };
 
  const getReadingTime = (content) => {
    if (!content) return '0 min read';
    const wordsPerMinute = 200;
    const wordCount = content.split(/\s+/).length;
    const minutes = Math.ceil(wordCount / wordsPerMinute);
    return `${minutes} min read`;
  };
 
  if (loading) return <div className="loading-spinner">Loading posts...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;

  return (
  <div className="blog-container">
      <div className="blog-header">
        {/* <h1>Latest Articles</h1> */}
        <div className="search-wrapper">
          <i className="fas fa-search search-icon"></i>
          <input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>
 
      <div className="articles-grid">
        {filtered.length === 0 ? (
          <div className="no-results">
            <p>No articles found matching your search.</p>
          </div>
        ) : (
          filtered.map(post => (
            <div
              key={post.id}
              className="article-card"
              onClick={() => navigate(`/posts/${post.id}`)}
            >
              <div className="card-content">
                <h2>{post.title}</h2>
                <p className="excerpt">{cleanContent(post.content)}</p>
                <div className="article-meta">
                  <span className="author">{post.author_name}</span>
                  <span className="date">{formatDate(post.created_at)}</span> 
                  {/* <span className="read-time">{getReadingTime(post.content)}</span> */}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

const CompactPostCard = ({ post, onClick, formatDate }) => (
  <div className="compact-card" onClick={onClick}>
    <div className="compact-card-content">
      <div className="compact-card-header">
        <span className="compact-badge"><i className="fas fa-newspaper"></i> Post</span>
        <span className="compact-category">{post.author_name}</span>
      </div>
      <h3 className="compact-title">{post.title}</h3>
      <div className="compact-meta">
        <i className="far fa-clock"></i> {formatDate(post.created_at)}
      </div>
      <div className="compact-footer">
        <span className="read-more">Read more <i className="fas fa-arrow-right"></i></span>
      </div>
    </div>
  </div>
);

export default Blogger;

